import * as $ from "jquery";
(<any>window).jQuery = $;

// http://kenwheeler.github.io/slick/
require('slick-carousel');

// https://github.com/cferdinandi/smooth-scroll
var SmoothScroll = require('smooth-scroll');

// 初期化
(() => {
	var $slider1    = $('.mainvisual-slider');
	var $slider2    = $('.menu-imgs-slider');
	var $slider3    = $('.menu-list-slider');
	var $slider_nav = $('.slider-nav');
	var maxPage     = $slider3.find('.slide').length;
	var pageCount   = function(currentPage, maxPage) {
		return currentPage + '／' + maxPage + 'ページ';
	}

	/*ハンバーガーメニュー*/
	$('.menu-trigger').on('click', function() {
		$(this).toggleClass('active');
		$('nav').stop().slideToggle();
		return false;
	});
	$('#global-menu').on('click', function() {
		$('.menu-trigger').toggleClass('active');
		$('nav').hide();
	});

	/*スライダー*/
	$slider1.on('init', function() {
		$('#mainvisual .slide').css('visibility', 'visible');
	});

	$slider2.on('init', function() {
		var $dots = $slider2.find('.slick-dots');
		$slider2.next().append($dots);
	});

	$('.slick-next', $slider_nav).on('click', function() {
		var target = $(this).data('target');
		$(target).slick('slickNext');
	});

	$('.slick-prev', $slider_nav).on('click', function() {
		var target = $(this).data('target');
		$(target).slick('slickPrev');
	});

	$slider3.on('afterChange', function() {
		var currentPage = $(this).slick('slickCurrentSlide');
		$slider3.next().find('.current-page').text(pageCount(currentPage + 1, maxPage));
	});

	$slider1.slick({
		autoplay     : true,
		autoplaySpeed: 5000,
		fade         : true
	});

	$slider2.slick({
		dots  : true,
		arrows: false
	});

	$slider3.slick({
		dots  : false,
		arrows: false
	});

	var topBtn = $('#pagetop');

	$(window).scroll(function() {
		var scroll = $(this).scrollTop();
		if ( scroll > window.innerHeight ) {
			topBtn.addClass('show');
		} else {
			topBtn.removeClass('show');
		}
	});

	var scroll = new SmoothScroll('a[href*="#"]', {
		header: '#header',
		speed : 500,
		offset: 0,
	});

})();



// WEBPACK FOOTER //
// ./httpdocs/assets/js/entry.ts